import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from "axios";
import Cookies from 'js-cookie';
import { getApiUrl } from '../functions/getApiUrl';

export const getTrips = createAsyncThunk(
  'trips/getTrips',
  async (args) => {
    const token = Cookies.get(`${process.env.REACT_APP_TOKEN_NAME}`)
    const res = await axios.get(getApiUrl(`/Trips/${args.page}?date=${args.date}`), {
      headers:{
        Authorization:`Bearer ${token}`
      }
    })
    return {data:res.data.data, count:res.data.count}
  },
)

const initialState = {
  trips: null,
  count: 0,
  isLoading:true
}

export const tripsSlice = createSlice({
  name: 'trips',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getTrips.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getTrips.fulfilled, (state, { payload }) => {
      state.trips = payload.data
      state.count = payload.count
      state.isLoading = false
    })
    builder.addCase(getTrips.rejected, (state, action) => {
      state.isLoading = false
      if (action.payload) {
        console.log(action.payload.errorMessage)
      } else {
        console.log(action.error)
      }
    })
  },
})


export default tripsSlice.reducer